import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import { Button, Table } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import ConfirmComponent from "../../app/common/form/ConfirmComponent";

export default observer(function BatchLettersHistoryPage() {
  const { emailLogStore, modalStore } = useStore();
  const [batchInfos, setBatchInfos] = useState<{ batchId: string, subject: string, createdAt: string }[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    emailLogStore.getBatchInfos().then(setBatchInfos);
  }, [emailLogStore]);

  const handleDeleteBatch = (batchId: string) => {
    modalStore.openModal(
      <ConfirmComponent
        text={t("general.areYouSure")}
        onYes={async () => {
          await emailLogStore.deleteBatch(batchId);
          setBatchInfos(batchInfos.filter(b => b.batchId !== batchId));
          modalStore.closeModal();
        }}
        onCancel={modalStore.closeModal}
      />
    );
  };

  return (
    <>
      <h3>{t("emails.batchLettersHistory.title")}</h3>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{t("emails.batchLettersHistory.batchId")}</Table.HeaderCell>
            <Table.HeaderCell>{t("emails.batchLettersHistory.subject")}</Table.HeaderCell>
            <Table.HeaderCell>{t("emails.batchLettersHistory.createdAt")}</Table.HeaderCell>
            <Table.HeaderCell>{t("emails.batchLettersHistory.actions")}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {batchInfos.length === 0 ? (
            <Table.Row>
              <Table.Cell colSpan={4} textAlign="center">
                {t("dataTable.noData")}
              </Table.Cell>
            </Table.Row>
          ) : (
            batchInfos.map(info => (
              <Table.Row key={info.batchId}>
                <Table.Cell>{info.batchId}</Table.Cell>
                <Table.Cell>{info.subject}</Table.Cell>
                <Table.Cell>
                  {info.createdAt && info.createdAt !== "0001-01-01T00:00:00" && info.createdAt !== "1970-01-01T00:00:00"
                    ? new Date(info.createdAt).toLocaleString()
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  <Button onClick={() => emailLogStore.downloadBatchPdf(info.batchId)}>
                    {t("emails.batchLettersHistory.downloadBatchPdf")}
                  </Button>
                  <Button color="red" onClick={() => handleDeleteBatch(info.batchId)} style={{ marginLeft: 8 }}>
                    {t("emails.templates.delete")}
                  </Button>
                </Table.Cell>
              </Table.Row>
            ))
          )}
        </Table.Body>
      </Table>
    </>
  );
});